/*
 * @Author: liu.huirong
 * @Date: 2021-05-19 14:22:57
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-12-30 15:02:38
 * @Params
 * [onPrevious]: Previous 按钮事件
 * [onContinue]: Continue 按钮事件
 * [continueContent]: Continue 按钮内容展示
 */

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button } from '@whalecloud/fdx';
import { i18n } from 'fishx';
import { connect } from 'react-redux';
import styles from './index.module.less';

const StepFooter = props => {
  const { onPrevious, onContinue, continueContent, className = '', footer = [], loading, needContinue = true } = props;

  return (
    <div className={`${styles.stepFooter} ${className}`}>
      {!isEmpty(footer) && footer.map(item => item)}
      {
        isEmpty(footer) && (
          <>
            <Button onClick={onPrevious}>{i18n('BUTTON_PREVIOUS')}</Button>
            {
              needContinue && (
              <Button onClick={onContinue} type="primary" loading={loading}>{continueContent || i18n('BUTTON_CONTINUE')}</Button>
              )
            }
          </>
        )
      }
    </div>
  );
};

export default connect()(StepFooter);
